import { useEffect, useState } from "react"
import Card from "../UI/Card"
import MealItem from "./MealItem/MealItem"

import classes from "./AvailableMeals.module.css"

const AvailableMeals = () => {
	const [meals, setMeals] = useState([])
	const [isLoading, setIsLoading] = useState(true)
	const [requestError, setRequestError] = useState(null)

	useEffect(() => {
		const fetchMeals = async () => {
			const response = await fetch(
				"https://tasks-menager-default-rtdb.firebaseio.com/meals.json"
			)

			if (!response.ok) {
				throw new Error("Cann't fetch data from server :(")
			}
			const responseData = await response.json()

			const loadedMeals = []

			for (const key in responseData) {
				loadedMeals.push({
					id: key,
					name: responseData[key].name,
					description: responseData[key].description,
					price: responseData[key].price,
				})
			}

			setMeals(loadedMeals)
			setIsLoading(false)
		}
		fetchMeals().catch((err) => {
			setIsLoading(false)
			setRequestError(err.message)
		})
	}, [])

	if (isLoading) {
		return (
			<sectction className={classes.mealsLoading}>
				<p>Loading...</p>
			</sectction>
		)
	}

	if (requestError) {
		return (
			<sectction className={classes.mealsError}>
				<p>{requestError}</p>
			</sectction>
		)
	}

	const mealsList = meals.map((meal) => (
		<MealItem
			id={meal.id}
			key={meal.id}
			name={meal.name}
			description={meal.description}
			price={meal.price}
		/>
	))

	return (
		<section className={classes.meals}>
			<Card>
				<ul>{mealsList}</ul>
			</Card>
		</section>
	)
}

export default AvailableMeals
